module.exports = __webpack_public_path__ + "static/bg-sidebar-conversions-276f83a4de4d1791de4077c428a0c576.svg";